import OverviewPage from 'pages/app/DACUM/Overview';
import { Navigate } from 'react-router-dom';
import CompetencyManagementPage from 'pages/app/DACUM/CompetencyManagement';
import DetailCompetencyPage from 'pages/app/DACUM/CompetencyManagement/DetailCompetency';
import AddCoreCompetencyPage from 'pages/app/DACUM/CompetencyManagement/AddCoreCompetency';
import EditCoreCompetencyPage from 'pages/app/DACUM/CompetencyManagement/EditCoreCompetency';
import EditCompetencyPage from 'pages/app/DACUM/CompetencyManagement/EditCompetency';
import MasterArea from 'pages/app/DACUM/MasterArea';
import MasterAreaAdd from 'pages/app/DACUM/MasterArea/Add';
import MasterAreaDetail from 'pages/app/DACUM/MasterArea/Detail';
import MasterAreaEdit from 'pages/app/DACUM/MasterArea/Edit';
import MasterUserAdminPage from 'pages/app/DACUM/MasterUserAdmin';
import AddMasterUserAdminPage from 'pages/app/DACUM/MasterUserAdmin/Add';
import MasterUserAdminDetailPage from 'pages/app/DACUM/MasterUserAdmin/Detail';
import EditMasterUserAdminPage from 'pages/app/DACUM/MasterUserAdmin/Edit';
import ModuleManagementPage from 'pages/app/DACUM/ModuleManagement';
import AddModuleManagementPage from 'pages/app/DACUM/ModuleManagement/Add';
import DetailModuleManagementPage from 'pages/app/DACUM/ModuleManagement/Detail';
import EditModuleManagementPage from 'pages/app/DACUM/ModuleManagement/Edit';
import ModuleManagementJobFamilyPage from 'pages/app/DACUM/ModuleManagementJobFamily';
import AddModuleManagementJobFamilyPage from 'pages/app/DACUM/ModuleManagementJobFamily/Add';
import DetailModuleManagementJobFamilyPage from 'pages/app/DACUM/ModuleManagementJobFamily/Detail';
import EditModuleManagementJobFamilyPage from 'pages/app/DACUM/ModuleManagementJobFamily/Edit';
import ReportPage from 'pages/app/DACUM/Report';
import ReviewMasterplanPage from 'pages/app/DACUM/ReviewMasterplan';
import DetailReviewMasterPlanPage from 'pages/app/DACUM/ReviewMasterplan/DetailReviewMasterPlan';
import CreateMasterPlanPage from 'pages/app/DACUM/ReviewMasterplan/CreateMasterPlan';
import EditMasterPlanPage from 'pages/app/DACUM/MasterPlan/Edit';
import MasterPlanDetailPage from 'pages/app/DACUM/MasterPlan/Detail';
import SchoolManagementPage from 'pages/app/DACUM/SchoolManagement';
import CreateSchoolPage from 'pages/app/DACUM/SchoolManagement/CreateSchool';
import DetailSchoolPage from 'pages/app/DACUM/SchoolManagement/DetailSchool';
import SchoolJobFamilyPage from 'pages/app/DACUM/SchoolManagement/JobFamily';
import CreateJobFamilyPage from 'pages/app/DACUM/SchoolManagement/JobFamily/CreateJobFamily';

export const pathnames = {
  overview: '/app/dacum/overview',
  competencyManagement: '/app/dacum/management-competency',
  detailCompetencyManagement: '/app/dacum/management-competency/detail',
  addCoreCompetency: '/app/dacum/management-competency/add',
  editCoreCompetency: '/app/dacum/management-competency/update/:id',
  editCompetencyManagement: '/app/dacum/management-competency/edit/:id',
  schoolManagement: '/app/dacum/management-school',
  createSchoolManagement: '/app/dacum/management-school/add',
  editSchoolManagement: '/app/dacum/management-school/edit/:id',
  detailSchoolManagement: '/app/dacum/management-school/:id',
  schoolJobFamily: '/app/dacum/school-management/job-family',
  jobFamily: '/app/dacum/school-management/job-family',
  addSchoolJobFamily: '/app/dacum/school-management/job-family/add',
  createJobFamily: '/app/dacum/school-management/job-family/create',
  editJobFamily: '/app/dacum/school-management/job-family/edit/:id',
  reviewMasterPlan: '/app/dacum/review-masterplan',
  createMasterPlan: '/app/dacum/review-masterplan/create',
  detailReviewMasterPlan: '/app/dacum/review-masterplan/:id',
  masterPlanDetail: '/app/dacum/masterplan/detail',
  editMasterPlan: '/app/dacum/masterplan/edit/:id',
  report: '/app/dacum/report',
  notifications: '/app/dacum/notifications',
  masterArea: '/app/dacum/master-area',
  masterAreaAdd: '/app/dacum/master-area/add',
  masterAreaEdit: '/app/dacum/master-area/edit/:id',
  masterAreaDetail: '/app/dacum/master-area/:id',
  masterUserAdmin: '/app/dacum/master-user-admin',
  masterUserAdminAdd: '/app/dacum/master-user-admin/add',
  masterUserAdminEdit: '/app/dacum/master-user-admin/edit/:id',
  masterUserAdminDetail: '/app/dacum/master-user-admin/:id',
  competencyModule: '/app/dacum/competency-module',
  createCompetencyModule: '/app/dacum/competency-module/add',
  editCompetencyModule: '/app/dacum/competency-module/edit/:id',
  competencyModuleDetail: '/app/dacum/competency-module/:id',
  competencyModuleJobFamily: '/app/dacum/competency-module/job-family',
  createCompetencyModuleJobFamily: '/app/dacum/competency-module/job-family/add',
  editCompetencyModuleJobFamily: '/app/dacum/competency-module/job-family/edit/:id',
  competencyModuleJobFamilyDetail: '/app/dacum/competency-module/job-family/:id'
};

const DACUMRoutes = [
  {
    path: '/app/dacum',
    element: <Navigate to={pathnames.overview} replace />
  },
  {
    path: pathnames.overview,
    element: <OverviewPage />
  },
  {
    path: pathnames.competencyManagement,
    element: <CompetencyManagementPage />
  },
  {
    path: pathnames.detailCompetencyManagement,
    element: <DetailCompetencyPage />
  },
  {
    path: pathnames.addCoreCompetency,
    element: <AddCoreCompetencyPage />
  },
  {
    path: pathnames.editCoreCompetency,
    element: <EditCoreCompetencyPage />
  },
  {
    path: pathnames.editCompetencyManagement,
    element: <EditCompetencyPage />
  },
  {
    path: pathnames.schoolManagement,
    element: <SchoolManagementPage />
  },
  {
    path: pathnames.detailSchoolManagement,
    element: <DetailSchoolPage />
  },
  {
    path: pathnames.createSchoolManagement,
    element: <CreateSchoolPage />
  },
  {
    path: pathnames.editSchoolManagement,
    element: <CreateSchoolPage />
  },
  {
    path: pathnames.reviewMasterPlan,
    element: <ReviewMasterplanPage />
  },
  {
    path: pathnames.createMasterPlan,
    element: <CreateMasterPlanPage />
  },
  {
    path: pathnames.detailReviewMasterPlan,
    element: <DetailReviewMasterPlanPage />
  },
  {
    path: pathnames.masterPlanDetail,
    element: <MasterPlanDetailPage />
  },
  {
    path: pathnames.editMasterPlan,
    element: <EditMasterPlanPage />
  },
  {
    path: pathnames.report,
    element: <ReportPage />
  },
  {
    path: pathnames.masterArea,
    element: <MasterArea />
  },
  {
    path: pathnames.masterAreaAdd,
    element: <MasterAreaAdd />
  },
  {
    path: pathnames.masterAreaEdit,
    element: <MasterAreaEdit />
  },
  {
    path: pathnames.masterAreaDetail,
    element: <MasterAreaDetail />
  },
  {
    path: pathnames.masterUserAdmin,
    element: <MasterUserAdminPage />
  },
  {
    path: pathnames.masterUserAdminAdd,
    element: <AddMasterUserAdminPage />
  },
  {
    path: pathnames.masterUserAdminEdit,
    element: <EditMasterUserAdminPage />
  },
  {
    path: pathnames.masterUserAdminDetail,
    element: <MasterUserAdminDetailPage />
  },
  {
    path: pathnames.schoolJobFamily,
    element: <SchoolJobFamilyPage />
  },
  {
    path: pathnames.createJobFamily,
    element: <CreateJobFamilyPage />
  },
  {
    path: pathnames.editJobFamily,
    element: <CreateJobFamilyPage />
  },
  {
    path: pathnames.competencyModule,
    element: <ModuleManagementPage />
  },
  {
    path: pathnames.createCompetencyModule,
    element: <AddModuleManagementPage />
  },
  {
    path: pathnames.editCompetencyModule,
    element: <EditModuleManagementPage />
  },
  {
    path: pathnames.competencyModuleDetail,
    element: <DetailModuleManagementPage />
  },
  {
    path: pathnames.competencyModuleJobFamily,
    element: <ModuleManagementJobFamilyPage />
  },
  {
    path: pathnames.createCompetencyModuleJobFamily,
    element: <AddModuleManagementJobFamilyPage />
  },
  {
    path: pathnames.editCompetencyModuleJobFamily,
    element: <EditModuleManagementJobFamilyPage />
  },
  {
    path: pathnames.competencyModuleJobFamilyDetail,
    element: <DetailModuleManagementJobFamilyPage />
  }
];

export default DACUMRoutes;
